import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { api } from "../lib/api";

export default function LegalPage() {
  const location = useLocation();
  const [content, setContent] = useState({});

  useEffect(() => {
    api.get("/content").then((r) => setContent(r.data || {})).catch(() => {});
  }, []);

  useEffect(() => {
    if (location.hash) {
      const el = document.querySelector(location.hash);
      if (el) setTimeout(() => el.scrollIntoView({ behavior: "smooth" }), 250);
    } else {
      window.scrollTo(0, 0);
    }
  }, [location.hash]);

  const company = {
    name: content.company_name || "Detergent Studio SRL",
    cui: content.company_cui || "[CUI de completat din admin]",
    reg: content.company_reg || "[Nr. Reg. Com. de completat din admin]",
    address: content.company_address || content.contact_address || "București, România",
    email: content.contact_email || "contact@detergentzilnic.ro",
    phone: content.contact_phone || "+40 721 000 000",
  };

  const SECTIONS = [
    {
      id: "termeni",
      title: "Termeni și condiții",
      body: [
        `Prin utilizarea site-ului detergentzilnic.ro ești de acord cu acești termeni. Site-ul este operat de ${company.name}, CUI ${company.cui}, Nr. Reg. Com. ${company.reg}, cu sediul în ${company.address}, email ${company.email}, telefon ${company.phone}.`,
        `${company.name} este comerciantul (vânzătorul) direct al produselor marca zilnic — nu suntem marketplace sau intermediar. Contractul de vânzare se încheie direct între tine și ${company.name}, care emite și factura aferentă fiecărei comenzi.`,
        "Prețurile afișate sunt în lei (RON) și includ TVA. Comenzile se confirmă telefonic sau prin email. Plata se face ramburs, la livrare. Prețurile pot fi actualizate fără notificare prealabilă, fără a afecta comenzile deja confirmate.",
        "Toate bunurile beneficiază de garanția legală de conformitate de minimum 2 ani, conform OUG nr. 140/2021 privind contractele de vânzare de bunuri.",
        "Ne rezervăm dreptul de a anula comenzi în caz de erori de preț sau indisponibilitate de stoc, cu informarea imediată a clientului.",
      ],
    },
    {
      id: "livrare",
      title: "Politica de livrare a comenzilor",
      body: [
        "Comenzile plasate și confirmate sunt expediate în aceeași zi lucrătoare sau în următoarea zi lucrătoare, prin curier rapid, oriunde în România. Termenul de livrare estimat este de 24-48 de ore de la expediere.",
        "Costul de livrare este de 19,99 lei pentru comenzile sub 300 lei și gratuit oriunde în țară pentru comenzile de minimum 300 lei. Costul exact este afișat în coș și înainte de finalizarea comenzii.",
        "Plata se face ramburs, direct la curier, la primirea coletului. Te rugăm să verifici coletul la livrare; dacă ambalajul este deteriorat vizibil, poți refuza primirea și ne contactezi imediat.",
      ],
    },
    {
      id: "anulare",
      title: "Politica de anulare a comenzilor",
      body: [
        "Poți anula gratuit orice comandă care nu a fost încă expediată, telefonic sau prin email, indicând numărul comenzii.",
        "Dacă comanda a fost deja expediată, o poți refuza la livrare fără nicio penalitate sau o poți returna conform politicii de retur de mai jos.",
        "Pentru anulare: sună-ne sau scrie-ne la datele de contact afișate, cu numărul comenzii (format DZ-xxxx).",
      ],
    },
    {
      id: "retur",
      title: "Politica de retur și retragere din contract",
      body: [
        "Conform OUG nr. 34/2014, ai dreptul să te retragi din contract în 14 zile calendaristice de la primirea produselor, fără a indica un motiv și fără penalități.",
        "Îți poți exercita dreptul de retragere online, prin funcția dedicată de pe site-ul nostru. Dacă o folosești, îți transmitem fără întârziere o confirmare de primire a retragerii pe email, cu conținutul acesteia și data transmiterii.",
        "Produsele returnate trebuie să fie sigilate, nefolosite și în ambalajul original. Costul transportului de retur este suportat de client. Rambursăm contravaloarea produselor (inclusiv costul de livrare standard) în maximum 14 zile de la primirea returului, prin transfer bancar.",
      ],
      cta: { label: "Retrage-te din contract aici", to: "/retragere" },
    },
    {
      id: "anpc",
      title: "ANPC — Soluționarea litigiilor (SAL / SOL)",
      body: [
        "În cazul unui litigiu, poți apela gratuit la procedura de soluționare alternativă a litigiilor (SAL) a ANPC.",
        "Poți folosi și platforma europeană de soluționare online a litigiilor (SOL).",
      ],
      links: [
        { label: "Platforma ANPC SAL", href: "https://reclamatiisal.anpc.ro" },
        { label: "Platforma europeană SOL", href: "https://ec.europa.eu/consumers/odr" },
      ],
    },
    {
      id: "gdpr",
      title: "Politica de confidențialitate (GDPR)",
      body: [
        `Operatorul datelor cu caracter personal este ${company.name}, ${company.address}, ${company.email}.`,
        "Colectăm numele, telefonul, adresa și adresa de email exclusiv pentru procesarea și livrarea comenzilor, emiterea facturilor și comunicările legate de comanda ta (temei: executarea contractului). Datele contului (email, parolă criptată) sunt folosite pentru autentificare.",
        "Datele nu sunt vândute și nu sunt partajate cu terți în scopuri de marketing. Sunt transmise doar curierului (pentru livrare) și, dacă e cazul, procesatorului de plăți și furnizorului de email tranzacțional.",
        "Ai dreptul la acces, rectificare, ștergere, portabilitate, restricționare și opoziție. Pentru exercitarea lor, scrie-ne. Poți depune plângere și la ANSPDCP (www.dataprotection.ro).",
        "Păstrăm datele comenzilor conform obligațiilor fiscale (de regulă 10 ani pentru documente financiar-contabile).",
      ],
    },
    {
      id: "cookies",
      title: "Politica de cookie-uri",
      body: [
        "Site-ul folosește cookie-uri strict necesare funcționării (coș de cumpărături, autentificare) și, doar cu acordul tău exprimat prin bannerul de consimțământ, cookie-uri de analiză.",
        "Îți poți schimba oricând opțiunea ștergând datele site-ului din browser și reîncărcând pagina.",
      ],
    },
  ];

  return (
    <main className="mx-auto max-w-3xl px-4 py-16 sm:px-6" data-testid="legal-page">
      <p className="text-xs font-bold uppercase tracking-[0.08em] text-navy">Informații legale</p>
      <h1 className="mt-3 font-display text-3xl font-bold tracking-tight text-navy sm:text-4xl">
        Termeni, livrare, retur și confidențialitate
      </h1>
      <p className="mt-3 text-sm text-muted2">
        Informațiile complete ale comerciantului și drepturile tale ca consumator, într-un singur loc.
      </p>

      <div className="mt-8 rounded-lg border border-line bg-skytint p-6" data-testid="legal-company-card">
        <p className="text-xs font-bold uppercase tracking-[0.08em] text-navy">Entitatea juridică</p>
        <p className="mt-2 text-sm font-bold text-navy" data-testid="legal-company-name">{company.name}</p>
        <p className="text-sm text-ink">CUI: {company.cui} · Nr. Reg. Com.: {company.reg}</p>
        <p className="text-sm text-ink">{company.address}</p>
        <p className="text-sm text-ink">{company.email} · {company.phone}</p>
      </div>

      <div className="mt-8 flex flex-col gap-8">
        {SECTIONS.map((s) => (
          <section key={s.id} id={s.id} className="scroll-mt-28 rounded-lg border border-line bg-white p-7" data-testid={`legal-section-${s.id}`}>
            <h2 className="font-display text-xl font-bold text-navy">{s.title}</h2>
            <div className="mt-3 flex flex-col gap-3 text-base leading-relaxed text-ink">
              {s.body.map((p, i) => (
                <p key={i}>{p}</p>
              ))}
            </div>
            {s.cta && (
              <Link
                to={s.cta.to}
                className="mt-5 inline-flex h-12 items-center rounded-lg bg-navy px-7 text-base font-bold text-white transition-colors hover:bg-navy-dark"
                data-testid="legal-withdrawal-cta"
              >
                {s.cta.label}
              </Link>
            )}
            {s.links && (
              <div className="mt-5 flex flex-wrap gap-3">
                {s.links.map((l) => (
                  <a
                    key={l.href}
                    href={l.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="rounded-lg border-[1.5px] border-navy px-5 py-2.5 text-sm font-bold text-navy transition-colors hover:bg-skytint"
                    data-testid={`legal-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                  >
                    {l.label}
                  </a>
                ))}
              </div>
            )}
          </section>
        ))}
      </div>
    </main>
  );
}
